import React from "react";
import { Link } from "react-router-dom";


function Informes() {

  return (
    <div className="container-fluid">
      <h1 className="fs-3 fw-bold">Informes</h1>
      <div className="mt-3">
        <div className="container mt-4">
          <div className="row">
            <div className="col-md-6 mb-3">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Informe de Horas Trabajadas</h5>
                  <p className="card-text">
                    Este apartado te permite sacar un listado con las horas trabajadas de cada trabajador.
                  </p>
                  <Link
                    to="/admin/informes/listadohoras"
                    className="btn"
                    style={{ background: "#FF7A00", color: "white" }}
                  >
                    Ver informe
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-3">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Informe de Incidencias</h5>
                  <p className="card-text">Este apartado te permite exportar un listado de las incidencias de cada trabajador.</p>
                  <Link
                    to="/admin/informes/listadoincidencias"
                    className="btn"
                    style={{ background: "#FF7A00", color: "white" }}
                  >
                  Ver informe
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {/* <div className="col-md-6 mb-3">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Informe de Asistencia</h5>
                  <p className="card-text">Próximamente</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-3">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Informe de Productividad</h5>
                  <p className="card-text">Próximamente</p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Informes;
